import { useState } from 'react'

import { useTranslation } from 'react-i18next'

import { ListPopularDirection, SearchExcursions } from 'widgets/excursions'

import { HeaderGoBack } from 'shared/ui/header-go-back'

import s from './styles.module.scss'

const SearchDirections = () => {
  const { t } = useTranslation()

  const [isSearch, setIsSearch] = useState<boolean>(false)

  return (
    <div className="container">
      <div className={s.header}>
        <HeaderGoBack
          title={t('to')}
          buttonWhite
        />
      </div>

      <SearchExcursions isSearchActive={setIsSearch} />

      {!isSearch && (
        <>
          <h4 className={s.title}>{t('popular_direction')}</h4>

          <div className={s.searchList}>
            <ListPopularDirection />
          </div>
        </>
      )}
    </div>
  )
}

export default SearchDirections
